import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { useField } from 'informed';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { Icon } from '../../Icons';
import '../styles/formFieldStyles.css';

import ToggleButton from './ToggleButton';

const Input = (props) => {
  const {
    disabled,
    field,
    getToggleButtonProps,
    hideDownButton,
    initialValue,
    inputRef,
    noBorder,
    onBlur,
    toggleButtonLabelText,
    userInput,
    validate,
    validateOnBlur,
    validateOnChange,
    validateOnMount,
    ...rest
  } = props;
  /**
   * if you need a custom onBlur or onChange etc, get it from 'props' because Informed
   * will not pass it on through the 'userProps' that you get back from useField
   */

  const { fieldApi, fieldState } = useField(props);
  const { setTouched } = fieldApi;
  const { error, touched, value } = fieldState;
  const validation = validateOnBlur || validateOnChange || validateOnMount;

  const statusClass =
    value && !error && touched && validation
      ? 'success'
      : value && error && 'error';

  const handleBlur = (event) => {
    onBlur(event);
    setTouched(true);
  };

  const handleClick = () => {
    setTouched(true);
  };

  return (
    <Fragment>
      <Icon className="absolute w-4 h-10 mx-2 my-0" icon={faSearch} />
      <input
        {...rest}
        className={`custom-field ${noBorder ? 'no-border' : ''} ${
          statusClass || ''
        } custom-input`}
        disabled={disabled}
        onBlur={handleBlur}
        onClick={handleClick}
        ref={inputRef}
        type="text"
        value={userInput}
      />
      {!hideDownButton && (
        <ToggleButton
          disabled={disabled}
          getToggleButtonProps={getToggleButtonProps}
          setTouched={setTouched}
          toggleButtonLabelText={toggleButtonLabelText}
        />
      )}
      {error && <small className="text-red-3">{error}</small>}
    </Fragment>
  );
};

Input.defaultProps = {
  disabled: false,
  hideDownButton: false,
  initialValue: '',
  noBorder: false,
  onBlur: () => {},
  toggleButtonLabelText: undefined,
  userInput: '',
};

Input.propTypes = {
  disabled: PropTypes.bool,
  field: PropTypes.string.isRequired,
  getToggleButtonProps: PropTypes.func.isRequired,
  hideDownButton: PropTypes.bool,
  initialValue: PropTypes.string,
  inputRef: PropTypes.func.isRequired,
  noBorder: PropTypes.bool,
  onBlur: PropTypes.func,
  toggleButtonLabelText: PropTypes.string,
  userInput: PropTypes.string,
  validate: PropTypes.func.isRequired,
  validateOnBlur: PropTypes.bool.isRequired,
  validateOnChange: PropTypes.bool.isRequired,
  validateOnMount: PropTypes.bool.isRequired,
};

export default Input;
